/* eslint-disable import/no-relative-packages */

import { sprintf } from '../../vendor/sprintf-js';
import { country } from '../localization';

const fmtHours = (h) => ((h > 5) ? `${h} часов` : ((h > 1) ? `${h} часа` : `${h} час`)); // eslint-disable-line no-nested-ternary
const fmtMins = (m) => ((m > 5) ? `${m} минут` : ((m > 1) ? `${m} минуты` : `${m} минута`)); // eslint-disable-line no-nested-ternary
// const fmtSeconds = (s) => ((s > 1) ? `${s} seconds` : `${s} second`);

// const fmtKilometers = (km) => ((km > 1) ? `${km} kilometers` : '1 kilometer');
const fmtMeters = (m) => ((m > 5) ? `${m} метров` : ((m > 1) ? `${m} метра` : '1 метр')); // eslint-disable-line no-nested-ternary
const fmtFeet = (m) => ((m > 5) ? `${m} футов` : ((m > 1) ? `${m} фута` : '1 фут')); // eslint-disable-line no-nested-ternary

export const ruTime = (duration) => {
  let durationText;

  const h = Math.round(duration / 3600);
  const m = Math.round(duration / 60) % 60;
  // const s = duration % 60;
  if (h > 0) {
    durationText = `${fmtHours(h)} ${fmtMins(m)}`;
    // if (s > 0) {
    //   durationText += ` ${fmtSeconds(s)}`;
    // }
  } else if (m > 0) {
    durationText = `${fmtMins(m)}`;
    // if (s > 0) {
    //   durationText += ` ${fmtSeconds(s)}`;
    // }
  } else {
    durationText = '0 минут';
    // durationText = `${fmtSeconds(s)}`;
  }

  return durationText;
};

export const ruDistance = (distance) => {
  let distanceText;

  if (country === 'US') {
    if (distance > 322) {
      distanceText = sprintf('%.1f миль', Math.floor(distance / 160.9) / 10);
    } else {
      distanceText = sprintf('%f миль', Math.floor(distance / 1609));
      distanceText = `${fmtFeet(Math.floor(3.28 * distance))}`;
    }
  } else {
    // const km = Math.floor(distance / 1000);
    const meters = distance % 1000;
    if (distance >= 100) {
      distanceText = sprintf('%.1f километров', distance / 1000);
    } else {
      // if (km > 0) {
      //   distanceText = `${fmtKilometers(km)}`;
      //   if (meters > 0) {
      //     distanceText += ` ${fmtMeters(meters)}`;
      //   }
      // } else {
      distanceText = `${fmtMeters(meters)}`;
      // }
    }
  }

  return distanceText;
};

export const ruLeg = (duration, distance) => {
  const durationText = ruTime(duration);
  const distanceText = ruDistance(distance);
  return `${durationText}, ${distanceText}`;
};

export default { ruLeg, ruTime, ruDistance };
